module.exports = __webpack_public_path__ + "static/pawn.7caf8bd1.svg";